module.exports = __webpack_public_path__ + "img/user_actived.3edd0b95.svg";